import type { Product } from "@/api/types";

/**
 * 금액 표시(상점·결제 설계 결정 7·8). 서버 가격 행 {currency, amountMicros} 를 통화 규칙대로(KRW·JPY 소수 없음, TWD 등은 Intl 기본) 그 나라 표기로.
 * 앱은 기기 스토어의 priceString 이 있으면 그것을 우선(AC0-190), 없을 때 이 폴백. 웹은 항상 이 값(결제 금액).
 */
export function formatMoney(money: { currency: string; amountMicros: number }, locale = "ko-KR"): string {
  const amount = money.amountMicros / 1_000_000;
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency: money.currency, currencyDisplay: "narrowSymbol" }).format(amount);
  } catch {
    return `${money.currency} ${amount.toLocaleString(locale)}`;
  }
}

export const productPrice = (p: Pick<Product, "price">) => formatMoney(p.price);
